import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { SourceSystemRepository } from '@front/repository/Api/SourceSystem';
import type { ISourceSystemRepository } from '@front/repository/Api/SourceSystem/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sourceSystemQueryKeys } from './queryKeys';

const repository = new SourceSystemRepository();

export const _create = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: ISourceSystemRepository.Create.Params) => {
      return repository.create(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    onSuccess: async (_data, variables) => {
      // 一覧は作成画面でアンマウントされていることが多く、デフォルトの refetchType: 'active' では再フェッチされない。
      // また UseQueryDefaultOptions が refetchOnMount: false のため、戻っても stale でもマウント時に取り直されない。
      await queryClient.invalidateQueries({
        queryKey: sourceSystemQueryKeys.list(variables.projectId),
        refetchType: 'all',
      });
    },
    ...UseMutationDefaultOptions,
  });
};
